/**
 * @generated SignedSource<<7ef5840d53b181fac376208c3dc7ca68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Day = "Friday" | "Monday" | "Saturday" | "Sunday" | "Thursday" | "Tuesday" | "Wednesday" | "%future added value";
export type ExcludedSlots = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type MaxSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type MeetingReliefSettingVisibility = "DisabledByPaywall" | "HideSetting" | "ShowWithBadge" | "ShowWithoutBadge" | "%future added value";
export type MinSlot = "T_00_00" | "T_00_30" | "T_01_00" | "T_01_30" | "T_02_00" | "T_02_30" | "T_03_00" | "T_03_30" | "T_04_00" | "T_04_30" | "T_05_00" | "T_05_30" | "T_06_00" | "T_06_30" | "T_07_00" | "T_07_30" | "T_08_00" | "T_08_30" | "T_09_00" | "T_09_30" | "T_10_00" | "T_10_30" | "T_11_00" | "T_11_30" | "T_12_00" | "T_12_30" | "T_13_00" | "T_13_30" | "T_14_00" | "T_14_30" | "T_15_00" | "T_15_30" | "T_16_00" | "T_16_30" | "T_17_00" | "T_17_30" | "T_18_00" | "T_18_30" | "T_19_00" | "T_19_30" | "T_20_00" | "T_20_30" | "T_21_00" | "T_21_30" | "T_22_00" | "T_22_30" | "T_23_00" | "T_23_30" | "%future added value";
export type NoMeetingDayOfWeek = "Friday" | "Monday" | "Saturday" | "Sunday" | "Thursday" | "Tuesday" | "Wednesday" | "%future added value";
export type WorkingHoursTypeEnum = "Base" | "Meeting" | "PreferredFocusTime" | "%future added value";
export type WebSettingsHoursAndPreferencesRelayQuery$variables = {
  orgRelayId: string;
};
export type WebSettingsHoursAndPreferencesRelayQuery$data = {
  readonly viewer: {
    readonly id: string;
  };
  readonly org: {
    readonly primaryOrgCalendar?: string;
    readonly experiments?: ReadonlyArray<string | null> | null;
    readonly primaryTeam?: {
      readonly __typename: "Team";
      readonly teamId: string;
      readonly settings: {
        readonly __typename: "TeamSettings";
        readonly useNoMeetingDay: boolean;
        readonly noMeetingDayOfWeek: NoMeetingDayOfWeek;
      } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
      readonly userSettings: {
        readonly __typename: "TeamUserSettings";
        readonly useNoMeetingDay: boolean;
      } | {
        readonly __typename: "GraphEntityError";
        readonly statusCode: number | null;
        readonly message: string | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      };
    } | {
      readonly __typename: "GraphEntityError";
      readonly statusCode: number | null;
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
    readonly userMeetingHours?: {
      readonly id: string;
      readonly hasBeenSet: boolean | null;
      readonly workingHours: {
        readonly id: string;
        readonly type: WorkingHoursTypeEnum | null;
        readonly timeZone: string | null;
        readonly daySettings: ReadonlyArray<{
          readonly day: Day | null;
          readonly setting: {
            readonly minSlot: MinSlot | null;
            readonly maxSlot: MaxSlot | null;
            readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
          } | null;
        } | null> | null;
        readonly dayOverrides: ReadonlyArray<{
          readonly date: string | null;
          readonly setting: {
            readonly minSlot: MinSlot | null;
            readonly maxSlot: MaxSlot | null;
            readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly userWorkingHours?: {
      readonly id: string;
      readonly hasBeenSet: boolean | null;
      readonly workingHours: {
        readonly id: string;
        readonly type: WorkingHoursTypeEnum | null;
        readonly timeZone: string | null;
        readonly daySettings: ReadonlyArray<{
          readonly day: Day | null;
          readonly setting: {
            readonly minSlot: MinSlot | null;
            readonly maxSlot: MaxSlot | null;
            readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
          } | null;
        } | null> | null;
        readonly dayOverrides: ReadonlyArray<{
          readonly date: string | null;
          readonly setting: {
            readonly minSlot: MinSlot | null;
            readonly maxSlot: MaxSlot | null;
            readonly excludedSlots: ReadonlyArray<ExcludedSlots | null> | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    readonly featureGrid?: {
      readonly __typename: "FeatureGrid";
      readonly featureStates: {
        readonly meetingReliefSettingVisibility: MeetingReliefSettingVisibility;
      };
    } | {
      readonly __typename: "GraphEntityError";
      readonly statusCode: number | null;
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    };
    readonly " $fragmentSpreads": FragmentRefs<"WorkPreferenceStartEndGoal_org">;
  } | null;
};
export type WebSettingsHoursAndPreferencesRelayQuery = {
  variables: WebSettingsHoursAndPreferencesRelayQuery$variables;
  response: WebSettingsHoursAndPreferencesRelayQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "orgRelayId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Viewer",
  "kind": "LinkedField",
  "name": "viewer",
  "plural": false,
  "selections": (v2/*: any*/),
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "orgRelayId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryOrgCalendar",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "experiments",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "teamId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useNoMeetingDay",
  "storageKey": null
},
v10 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noMeetingDayOfWeek",
      "storageKey": null
    }
  ],
  "type": "TeamSettings",
  "abstractKey": null
},
v11 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "statusCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "GraphEntityError",
  "abstractKey": null
},
v12 = {
  "kind": "InlineFragment",
  "selections": [
    (v9/*: any*/)
  ],
  "type": "TeamUserSettings",
  "abstractKey": null
},
v13 = [
  {
    "kind": "Literal",
    "name": "resolveOverrides",
    "value": false
  }
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "WorkingSetting",
  "kind": "LinkedField",
  "name": "setting",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "minSlot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "maxSlot",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "excludedSlots",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasBeenSet",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "WorkingHours",
    "kind": "LinkedField",
    "name": "workingHours",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DaySetting",
        "kind": "LinkedField",
        "name": "daySettings",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "day",
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DayOverride",
        "kind": "LinkedField",
        "name": "dayOverrides",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "UserMeetingHours",
  "kind": "LinkedField",
  "name": "userMeetingHours",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": "userMeetingHours(resolveOverrides:false)"
},
v17 = {
  "alias": null,
  "args": (v13/*: any*/),
  "concreteType": "UserWorkingHours",
  "kind": "LinkedField",
  "name": "userWorkingHours",
  "plural": false,
  "selections": (v15/*: any*/),
  "storageKey": "userWorkingHours(resolveOverrides:false)"
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "featureGrid",
  "plural": false,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FeatureStates",
          "kind": "LinkedField",
          "name": "featureStates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "meetingReliefSettingVisibility",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "FeatureGrid",
      "abstractKey": null
    },
    (v11/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": (v2/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WebSettingsHoursAndPreferencesRelayQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": "org",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WorkPreferenceStartEndGoal_org"
              },
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "primaryTeam",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "settings",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "userSettings",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v12/*: any*/),
                          (v11/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Team",
                    "abstractKey": null
                  },
                  (v11/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WebSettingsHoursAndPreferencesRelayQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": "org",
        "args": (v4/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1000000
                  }
                ],
                "concreteType": "GoalConnection",
                "kind": "LinkedField",
                "name": "userGoals",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "GoalEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Goal",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "goalId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDeleted",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GoalOptions",
                            "kind": "LinkedField",
                            "name": "options",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "syncToGoogle",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "specificOptions",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "keepEndOfDayOpen",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "keepStartOfDayOpen",
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "GoalPreferredWorkOptions",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "userGoals(first:1000000)"
              },
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "primaryTeam",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "settings",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v10/*: any*/),
                          (v11/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "userSettings",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v12/*: any*/),
                          (v11/*: any*/),
                          (v19/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Team",
                    "abstractKey": null
                  },
                  (v11/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              },
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "type": "Org",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4b7d0d97e43221849cbe656ec00754a4",
    "id": null,
    "metadata": {},
    "name": "WebSettingsHoursAndPreferencesRelayQuery",
    "operationKind": "query",
    "text": "query WebSettingsHoursAndPreferencesRelayQuery(\n  $orgRelayId: ID!\n) {\n  viewer {\n    id\n  }\n  org: node(id: $orgRelayId) {\n    __typename\n    ... on Org {\n      ...WorkPreferenceStartEndGoal_org\n      primaryOrgCalendar\n      experiments\n      primaryTeam {\n        __typename\n        ... on Team {\n          teamId\n          settings {\n            __typename\n            ... on TeamSettings {\n              useNoMeetingDay\n              noMeetingDayOfWeek\n            }\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n          userSettings {\n            __typename\n            ... on TeamUserSettings {\n              useNoMeetingDay\n            }\n            ... on GraphEntityError {\n              statusCode\n              message\n            }\n            ... on Node {\n              __isNode: __typename\n              id\n            }\n          }\n        }\n        ... on GraphEntityError {\n          statusCode\n          message\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      userMeetingHours(resolveOverrides: false) {\n        id\n        hasBeenSet\n        workingHours {\n          id\n          type\n          timeZone\n          daySettings {\n            day\n            setting {\n              minSlot\n              maxSlot\n              excludedSlots\n            }\n          }\n          dayOverrides {\n            date\n            setting {\n              minSlot\n              maxSlot\n              excludedSlots\n            }\n          }\n        }\n      }\n      userWorkingHours(resolveOverrides: false) {\n        id\n        hasBeenSet\n        workingHours {\n          id\n          type\n          timeZone\n          daySettings {\n            day\n            setting {\n              minSlot\n              maxSlot\n              excludedSlots\n            }\n          }\n          dayOverrides {\n            date\n            setting {\n              minSlot\n              maxSlot\n              excludedSlots\n            }\n          }\n        }\n      }\n      featureGrid {\n        __typename\n        ... on FeatureGrid {\n          featureStates {\n            meetingReliefSettingVisibility\n          }\n        }\n        ... on GraphEntityError {\n          statusCode\n          message\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment WorkPreferenceStartEndGoal_org on Org {\n  id\n  userGoals(first: 1000000) {\n    edges {\n      node {\n        id\n        goalId\n        name\n        isDeleted\n        options {\n          syncToGoogle\n          specificOptions {\n            __typename\n            ... on GoalPreferredWorkOptions {\n              keepEndOfDayOpen\n              keepStartOfDayOpen\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6bf1bf45ab5fdc0619f578551a4bfdda";

export default node;
